import { Box, TextField, Typography } from "@mui/material";

const ConnectWebsiteStep = ({ website, setWebsite }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2.5,
        p: 2,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
      }}
    >
      <Typography variant="subtitle1" fontWeight={600}>
        Website Details
      </Typography>

      <TextField
        label="Website Name"
        value={website.name}
        onChange={(e) => setWebsite({ ...website, name: e.target.value })}
        fullWidth
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
          },
        }}
      />

      <TextField
        label="Website URL"
        value={website.url}
        onChange={(e) => setWebsite({ ...website, url: e.target.value })}
        placeholder="https://example.com"
        fullWidth
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
          },
        }}
      />
    </Box>
  );
};

export default ConnectWebsiteStep;
